import React from 'react';
import './ManualDownload.css';

export default function ManualDownload() {
  return <a className="manual-download" href={`${process.env.PUBLIC_URL || ''}/manuals/MSU-Research-Ethics-User-Manual.pdf`} download="MSU Research Ethics User Manual.pdf">
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5"/></svg>
    <span>Download user manual <small>PDF</small></span>
  </a>;
}
